import { render } from "./z-description.vue?vue&type=template&id=09dc9550"
import script from "./z-description.vue?vue&type=script&lang=js"
export * from "./z-description.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__